import { render, staticRenderFns } from "./EmployeeDocumentsManager.vue?vue&type=template&id=d59168d4&scoped=true"
import script from "./EmployeeDocumentsManager.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsManager.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDocumentsManager.vue?vue&type=style&index=0&id=d59168d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59168d4",
  null
  
)

export default component.exports